export default {"src":"/_next/static/media/instagram_icon.4a77113f.svg","height":56,"width":56};